import sinusoidal from "./Sinusoidal.js";
import linear from "./Linear.js";
import exponential from "./Exponential.js";
import square from "./Square.js";
import staircase from "./Staircase.js";

export {sinusoidal, linear, staircase, square, exponential};